import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUserData, logout } from "../redux/slices/userSlices";
import { useEffect } from "react";
import Api from "../components/api/api";
import { URL_API } from "../components/constants/api";

export default function Logout() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const dataUser = useSelector(getUserData);

  useEffect(() => {
    // Thu hồi token trên server (lỗi mạng thì vẫn đăng xuất ở máy)
    if (dataUser?.token) {
      Api.post(URL_API.LOGOUT, {}, dataUser.token).catch(() => {});
    }
    dispatch(logout());
    navigate("/");
  }, []);

  return <div className="w-full min-h-dvh bg-gradient-custom"></div>;
}
